import React from "react";
import { Modal } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { toAbsoluteUrl, formatCcmodePrice } from "../../_helpers";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import DiamondTypeTag from "./DiamondTypeTag";
import CertificateLink from "../CertificateLink";

const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};

const useStyle = makeStyles((theme) => ({
    listContrainer: {
        position: "relative",
    },
    listItemError: {
        position: "absolute",
        zIndex: "1",
        fontSize: "1.2rem",
        fontWeight: "bold",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "max-content",
        background: "hsl(0, 0%, 100%, 70%)",
        padding: "4px 20px",
        borderRadius: "15px",
    },
    blurItem: {
        filter: "blur(2px)",
    },
}));

export const ConfirmStatusPopUpNew = (props) => {
    const classes = useStyle();

    const { hideCertificateNumber, hidePrice, isBuyRequest } = useSelector(
        (state) => {
            return state.CcModeSettingReducer;
        }
    );

    return (
        <>
            <Modal
                show={props.show}
                onHide={props.onClose}
                backdrop="static"
                keyboard={false}
                className={"natTab"}
            >
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center mb-10">
                                <h3 className="text-dark font-weight-bold">
                                    {isBuyRequest
                                        ? "Buy Request Sent"
                                        : "Diamonds Confirmed"}
                                </h3>
                            </div>
                            <PerfectScrollbar
                                options={perfectScrollbarOptions}
                                className="scroll border-bottom"
                                style={{
                                    maxHeight: "322px",
                                    position: "relative",
                                }}
                            >
                                {props.diamondstatus &&
                                    props.diamondstatus.map((data) => (
                                        <div
                                            className={classes.listContrainer}
                                            key={data.Id}
                                        >
                                            {data.status !== "Confirmed" && (
                                                <div
                                                    className={`text-danger ${classes.listItemError}`}
                                                >
                                                    Oops! You missed it – stone
                                                    unavailable.
                                                </div>
                                            )}
                                            <div
                                                className={`d-flex w-100 mb-4 pb-4 px-4 justify-content-between ${
                                                    data.status !== "Confirmed"
                                                        ? classes.blurItem
                                                        : ""
                                                }`}
                                            >
                                                <div className="d-flex">
                                                    <div className="text-center p-0">
                                                        {data.AWS_Image &&
                                                        data.AWS_Image !==
                                                            "null" ? (
                                                            <img
                                                                className="img-fluid mr-2"
                                                                alt={
                                                                    data.C_Shape
                                                                }
                                                                src={
                                                                    data.AWS_Image
                                                                }
                                                                onError={(
                                                                    e
                                                                ) => {
                                                                    e.currentTarget.src = data?.sample
                                                                }}
                                                                width="115px"
                                                            />
                                                        ) : (
                                                            <img
                                                                className="img-fluid mr-2"
                                                                alt={
                                                                    data.C_Shape
                                                                }
                                                                src={data?.sample}
                                                                onError={(
                                                                    e
                                                                ) => {
                                                                    e.currentTarget.src = toAbsoluteUrl(
                                                                        `/media/shape/noimage.png`
                                                                    );
                                                                }}
                                                                width="115px"
                                                                style={{
                                                                    backgroundColor:
                                                                        "#f4f4f4",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="pl-2 p-0 text-left">
                                                        <div
                                                            className={`mb-1 ${
                                                                data.diamond_type ===
                                                                    "N" ||
                                                                data.diamond_type ===
                                                                    "W"
                                                                    ? "natTab"
                                                                    : "labTab"
                                                            }`}
                                                        >
                                                            <DiamondTypeTag diamondTypeTagColor={data.diamondTypeTagColor} diamondTypeTag={data.diamondTypeTag}/>
                                                            <span
                                                                className={`text-primary font-weight-bold small ml-1`}
                                                            >
                                                                {data.diamond_type ===
                                                                    "N" ||
                                                                data.diamond_type ===
                                                                    "W"
                                                                    ? "N"
                                                                    : "L"}
                                                                -
                                                                {data.ProductId}
                                                            </span>
                                                            {hideCertificateNumber ? (
                                                                ""
                                                            ) : (
                                                                <CertificateLink  Certificate_link={data.CERTIFICATE_LINK} lab={data.Lab} certificate={data.Certi_NO} className={`text-primary font-weight-bold mx-2 small`} />
                                                            )}
                                                        </div>
                                                        <div className="text-dark font-size-h6 font-weight-bold d-block">
                                                            {data.C_Shape}
                                                            {parseFloat(
                                                                data.C_Weight
                                                            ).toFixed(2)}
                                                            {data.C_Color ===
                                                            "fancy" ? (
                                                                <>
                                                                    {
                                                                        data.f_color
                                                                    }{" "}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {
                                                                        data.C_Color
                                                                    }{" "}
                                                                </>
                                                            )}
                                                            {data.C_Clarity}
                                                            {data.C_Cut}
                                                            {data.C_Polish}
                                                            {data.C_Symmetry}
                                                            {
                                                                data.C_Fluorescence
                                                            }
                                                        </div>
                                                        <div
                                                            className={`small mb-1 ${
                                                                data.status ===
                                                                "Confirmed"
                                                                    ? "text-success"
                                                                    : "text-danger"
                                                            }`}
                                                        >
                                                            <em>
                                                                {data.status}
                                                            </em>
                                                        </div>
                                                        <div>
                                                            {!hidePrice && (
                                                                <div className="d-flex">
                                                                    <div className="mr-4">
                                                                        <p className="text-muted font-weight-bold small mb-0 text-uppercase">
                                                                            {localStorage.getItem(
                                                                                "user_currency"
                                                                            )}
                                                                            /CT
                                                                        </p>
                                                                        <p className="text-dark font-size-h6 font-weight-bold">
                                                                            {data?.SELECTED_CURRENCY_LIST_PRICE_PER_CARAT_LABEL ||
                                                                                formatCcmodePrice(
                                                                                    props.GetPricePerCarat(
                                                                                        data
                                                                                    ),
                                                                                    localStorage.getItem(
                                                                                        "user_currency"
                                                                                    )
                                                                                )}
                                                                        </p>
                                                                    </div>

                                                                    <div className="">
                                                                        <p className="text-muted font-weight-bold small mb-0 text-uppercase">
                                                                            Total
                                                                        </p>
                                                                        <p className="text-dark font-size-h6 font-weight-bold">
                                                                            {data?.SELECTED_CURRENCY_LIST_PRICE_LABEL ||
                                                                                formatCcmodePrice(
                                                                                    props.GetPrice(
                                                                                        data
                                                                                    ),
                                                                                    localStorage.getItem(
                                                                                        "user_currency"
                                                                                    )
                                                                                )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </PerfectScrollbar>
                        </div>
                        <div className="col-12 text-right mt-5">
                            <Link
                                onClick={() => props.onClose()}
                                className="btn ml-2 btn-primary"
                            >
                                Back to cart
                            </Link>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
